import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import cardBodyStyle from '~/components/Commons/Card/cardBodyStyle';
import { CustomCardProps } from './Card';

function CardBody({ ...props }: CustomCardProps) {
  const { children } = props;
  const cardBodySx = {
    ...cardBodyStyle.cardBody,
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box sx={cardBodySx} {...props}>
      {children}
    </Box>
  );
}

CardBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.bool,
  plain: PropTypes.bool,
  formHorizontal: PropTypes.bool,
  color: PropTypes.bool,
};

CardBody.defaultProps = {
  children: null,
  className: '',
  background: false,
  plain: false,
  formHorizontal: false,
  color: false,
};

export default CardBody;
